// Where a contact came from — mirrors Teletel::ContactEntrySource on the
// backend. Stored values are the Arabic labels; keys drive the translations.
export const ENTRY_SOURCE_KEY = 'entry_source';
export const CONTACT_ENTRY_SOURCE_KEY = 'contact_entry_source';

export const ENTRY_SOURCE_VALUES = [
  { id: 'رسالة واردة', i18nKey: 'INCOMING_MESSAGE' },
  { id: 'بدأها موظف', i18nKey: 'STAFF_STARTED' },
  { id: 'استيراد ملف', i18nKey: 'FILE_IMPORT' },
  { id: 'إدخال يدوي', i18nKey: 'MANUAL_ENTRY' },
  { id: 'زائر موقع', i18nKey: 'WEBSITE_VISITOR' },
];

export const entrySourceOptions = t =>
  ENTRY_SOURCE_VALUES.map(({ id, i18nKey }) => ({
    id,
    name: t(`TELETEL_CONTACT_SOURCE.VALUES.${i18nKey}`),
  }));
